import { 
	SHOW_ALERT
} from '../types';

import { setMessage, hideAlert } from '../actions/uiActions';

export const uiMiddleware = ({dispatch}) => (next) => {
	return (action) => {
		if(action.type === SHOW_ALERT) {
			dispatch(setMessage(action.payload));

			if(action.payload.type === 'emailVerify' || action.payload.type === 'approve') {
				
			} else {
				return setTimeout(() => {
					dispatch(hideAlert());
				},5000);
			};
		};

		return next(action);
	};
};
